import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 11
  },
  palette: {
    primary: {
      main: '#262525',
    },
    secondary: {
      main: '#ff6400',
    },
  },
});

export default theme;